<template>
  <div
    class="bottom-bar"
    :class="[
      $route.path !== '/' && $route.path !== '/waitlist' && $route.path.split('/').length === 2
        ? ''
        : 'center',
        $route.name === 'Home'
        ? 'at-home'
        : 'not-at-home',
    ]"
  >
    <div
      :class="[
        $route.meta.smallBackButton
          ? 'small-back-button'
          : 'normal-back-button',
      ]"
    >
      <router-link
        class="back"
        v-if="$route.path.split('/').length > 2 && $route.meta.smallBackButton"
        :to="{
          name: $router.resolve(getPreviousRoute($route.path)).name,
        }"
      >
        <svg
          width="8"
          height="14"
          viewBox="0 0 8 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0.226562 14L7.22656 7L0.226562 0V14Z" fill="#ffffff" />
        </svg>
      </router-link>
      <router-link
        v-if="$route.path.split('/').length > 2"
        :to="{ name: 'Home' }"
        ><img src="@/assets/icons/home.svg" alt=""
      /></router-link>
      <router-link
        v-if="!$route.meta.smallBackButton && $route.path.split('/').length > 2"
        :to="{
          name: $router.resolve(getPreviousRoute($route.path)).name,
        }"
        ><img src="@/assets/icons/breadcrumbs-arrow.svg" alt="" />{{
          mapPageName($router.resolve(getPreviousRoute($route.path)).name)
        }}</router-link
      >
    </div>
    <div v-if="$route.meta.ctaText" class="cta">
      <div class="text">
        {{ $route.meta.ctaText }}
      </div>
      <button class='upgrade' @click="showUpgrade = true" v-if="$route.meta.showUpgradeButton && !$route.meta.showChatButton">
        <img src="@/assets/icons/upgrade.svg" alt="" />
        <span>Upgrade your Plan</span>
      </button>
      <button
        @click="showSatisfi"
        class="chat"
        v-if="$route.meta.showChatButton"
      >
        <img src="@/assets/icons/chat.svg" alt="" />
        <span>Chat with a Lions Representative</span>
      </button>
    </div>
    <router-link
      v-if="$route.path !== '/' && $route.path.split('/').length === 2"
      :to="{ name: 'Home' }"
      ><img src="@/assets/icons/breadcrumbs-arrow.svg" alt="" />Ticket Finder
      Home</router-link
    >    
    <img
      class='driven'
      style="visibility:hidden; pointer-events:none;"
      :class="[$route.meta.smallBackButton
          ? 'small-back'
          : 'normal-back', $route.path.split('/').length > 2 ? '' : 'driven-by-detroit',
          $route.name === 'Multi-Game Plans' ? 'right' : ''
          ]"
      src="@/assets/logos/detroit-lions.svg"
      alt=""
    />
  </div>
  <PlanTypesModal type='multi-game-plans' @close="showUpgrade = false" v-show="showUpgrade"/>
</template>
<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import PlanTypesModal from "@/components/PlanTypesModal";

const showUpgrade = ref(false);
const router = useRouter();
const store = useStore();
function showSatisfi() {
  SatisfiApp.Global.chatPopupOpen();
}
function mapPageName(page) {
  let mapping = {
    'Group Tickets - Style Of Plan' : 'Back to type of plan',
  }
  return mapping[page] ?? page;
}
function getPreviousRoute(route) {
  let path = route.split("/");
  if (
    ["Stadium Pass", "Blue Mini-Plan", "Silver Mini-Plan"].includes(
      store.state.activePlan
    )
  ) {
    path.pop();
  }
  path.pop();

  return router.resolve(path.join("/"));
}
</script>

<style lang="scss" scoped>
.cta {
  width: 50%;
  text-align: center;
  a,
  button {
    margin: 0 auto;
    margin-top: 20px;       
    background: none;
    border:none;
  }
  .upgrade {
    display: inline-flex;
    
  }
  .text {
    font-family: "United Sans Cd Bd";
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    line-height: 1;
    text-align: center;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #ffffff;
    gap: 20px;
    &:after,
    &:before {
      content: "";
      flex-grow: 1;
      height: 1px;
      background: #fff;
    }
  }
}
.normal-back-button {
  display: contents;
}
.small-back-button {
  display: flex;
  gap: 20px;
  flex-direction: column;
  margin-right: 40px;
  a {
    flex-shrink: 0;
    &.back {
      display: grid;
      place-items: center;
      aspect-ratio: 1;
    }
    svg {
      transform: rotateY(180deg);
    }
  }
}
.bottom-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 60px;
  position: relative;
  margin-top: 60px;
  min-height: 64px;
  gap:15px;
  &.center {
    justify-content: space-between;
  }
}
@media (max-width:499px) {
  .driven {
    display:none;
  }
}
.not-at-home .driven.normal-back {
  @media (max-width:500px) {    
    position: absolute;
  right: 0;
  }
}
.at-home .driven.normal-back, .driven.right {  
  position: absolute;
  right: 0;  
}
a,
button,
.chat {
  user-select: none;
  font-family: "United Sans Cd Hv";
  font-weight: 900;
  border: 2px solid #fff;
  padding: 10px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #fff;
  font-size: 1.125rem;
  line-height: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  border-top-left-radius: 5px;
  border-bottom-right-radius: 5px;
  img {
    transform: rotateY(180deg);
  }  
}
.chat {
  @media (max-width:500px) {
    
    span {
      display:none;
  }
    }
}
</style>